// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    lensDiscoverabilityTagsLabel: {
        id: "apps.lensDiscoverability.models.lensDiscoverabilityTagsLabel",
        description: "Lens discoverability tags label.",
        defaultMessage: "Tags",
    },
    lensDiscoverabilityDescriptionLabel: {
        id: "apps.lensDiscoverability.models.lensDiscoverabilityDescriptionLabel",
        description: "Lens discoverability description label.",
        defaultMessage: "Description",
    },
    lensDiscoverabilityLocationsLabel: {
        id: "apps.lensDiscoverability.models.lensDiscoverabilityLocationsLabel",
        description: "Lens discoverability locations label.",
        defaultMessage: "Locations",
    },
    lensDiscoverabilityDaysTimesHolidaysLabel: {
        id: "apps.lensDiscoverability.models.lensDiscoverabilityDaysTimesHolidaysLabel",
        description: "Lens discoverability days times holidays label.",
        defaultMessage: "Timeslots and Holidays",
    },
});
